module.exports = __webpack_public_path__ + "media/images/flags/32/Tanzania-69457ad6c95995cf7539771500cd3a7e.png";